import React, { useEffect, useState } from 'react';
import { Button, Table, TableBody, TableHead, TableRow, TableCell } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom'
import { rolesAllById } from '../../../api/list'
import { fetchDispath } from '../../../functions/fetch'
import { Typography } from '@mui/material';

export default function RolesOne() {
    const history = useHistory()
    const { idDoc } = useParams()
    const dispatch = useDispatch()
    const [role, setRole] = useState({ id: '', name: '' })
    const [permissions, setPermissions] = useState([])
    useEffect(() => {
        dispatch(fetchDispath({
            progress: true,
            request: rolesAllById,
            param: {
                id: idDoc
            }
        })).then(res => {
            setRole(res.get.role)
            setPermissions(res.get.permissions)
        }).catch(err => console.log(err))
    }, [dispatch, idDoc])
    return (
        <div className='App-paper'>
            <Typography variant='h6'>{role.name}</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Группа</TableCell>
                        <TableCell>Наименование</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {permissions.map(e => {
                        return <TableRow key={e.id}>
                            <TableCell>{e.groupName}</TableCell>
                            <TableCell>{e.label}</TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>

            <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        </div>
    );
}